import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import PubSub from "services/PubSub/";
import AddressService from "services/Address/";
import StorageService from 'services/StorageService/';
import TagManagerService from 'services/TagManager';
import LoginService from "services/Login/";
import { elipsis } from 'utils';
import { actionsType } from 'config/constants';
import { deliverySelectorTxt } from 'config/translate/variables';
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss';//NOSONAR

let actions = [];

const DeliverySelector = (props) => {
    let deliveryType = '';
    let fullAddress = '';
    let formattedAddress = '';
    const [logged, setIsLogged] = useState(false);
    const [storeName, setStoreName] = useState(null);
    const [addressSelected, setAddressSelected] = useState(StorageService.getSecureItem('address'));
    const isMobile = useViewportMediaQuery(1121)

    useEffect(() => {
        init();
        Logged();

        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, init));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }

    }, []);

    const init = () => {
        setAddressSelected(StorageService.getSecureItem('address'));
        setStoreName(AddressService.getStoreName());
    };


    const Logged = () => {
        setIsLogged(LoginService.isLogged());

    };

    if(addressSelected){
        fullAddress = addressSelected.street + ', ' + (addressSelected.number ? addressSelected.number + ', ' : '');
        if (!props.elipsis) {
            formattedAddress = fullAddress;
        } else {
            formattedAddress = elipsis(fullAddress, props.elipsis)
        }
    }

    deliveryType = AddressService.getDeliveryMode();

    const openDeliverySelector = () => {
        PubSub.dispatch('delivery_selector_open');
        TagManagerService.clickHeader('Cambio de Ciudad', 'Header');
    }

    const addressDelivery = formattedAddress.concat((deliveryType === 'seller-1-sla-DespachoaDomicilio' || deliveryType === 'seller-1-sla-Express') ? storeName : '');
    const jumboChile = storeName === 'Jumbo Chile';

    return (
        <div className={"new-header-delivery-adress-wrap " + (logged ? ' is-logged' : '') + (deliveryType === 'seller-1-sla-RetiroenTienda' || deliveryType === 'seller-1-sla-ClickalAuto' || jumboChile ? ' delivery-store ' : '')}>
            <div className={'header-delivery-adress-content'} >
                {!isMobile && <span className="new-header-delivery-mode-title">{jumboChile ? 'Selecciona tu' : ''}</span>}

                {(deliveryType === 'seller-1-sla-DespachoaDomicilio' || deliveryType === 'seller-1-sla-Express') && fullAddress &&
                <div className="new-header-change-title-delivery-options-home">
                    <button className="delivery-options-mode" onClick={openDeliverySelector}>{deliveryType === 'seller-1-sla-Express' ? deliverySelectorTxt.express : deliverySelectorTxt.delivery}</button>

                    <div className="delivery-option-info-wrap">
                        <button className="deliver-address" onClick={openDeliverySelector}>{elipsis(addressDelivery, 30)}</button>
                        {isMobile && <button onClick={openDeliverySelector} className="new-header-change-adress-button-mobile mobile-click">{deliverySelectorTxt.change}</button>}
                    </div>
                </div>}

                {deliveryType === 'seller-1-sla-RetiroenTienda' && (!jumboChile) &&
                    <div className="new-header-change-title-delivery-options-store">
                        <span className="delivery-options-mode" onClick={openDeliverySelector}>{deliverySelectorTxt.store}</span>

                        <div className="delivery-option-info-wrap">
                            <span className="new-header-adress-title" onClick={openDeliverySelector}>{storeName}</span>
                            {isMobile && <button onClick={openDeliverySelector} className="new-header-change-adress-button-mobile mobile-click">{deliverySelectorTxt.change}</button>}
                        </div>
                    </div>
                }

                {deliveryType === 'seller-1-sla-ClickalAuto' && (!jumboChile) &&
                    <div className={"new-header-change-title-delivery-options-car " + (jumboChile ? ' hidden' : '')}>
                        <button className="delivery-options-mode" onClick={openDeliverySelector}>{deliverySelectorTxt.car}</button>

                        <div className="delivery-option-info-wrap">
                            <span className="new-header-adress-title" onClick={openDeliverySelector}>{storeName}</span>
                            {isMobile && <button onClick={openDeliverySelector} className="new-header-change-adress-button-mobile mobile-click">{deliverySelectorTxt.change}</button>}
                        </div>
                    </div>
                }

                {<button onClick={openDeliverySelector} className="new-header-change-adress-button mobile-click">{jumboChile ? deliverySelectorTxt.deliveryMode : (isMobile ? deliverySelectorTxt.change : '')}</button>}

                {jumboChile && <div>
                    <span className="new-header-adress-title-mobile">{deliverySelectorTxt.notSelected}</span>
                    {isMobile && <button onClick={openDeliverySelector} className="new-header-select-adress-button-mobile">{deliverySelectorTxt.select}</button>}
                </div>}
            </div>

            <button className="delivery-icon-content" onClick={openDeliverySelector}><i className="font-icn arrow-up"></i></button>
        </div>

    )
}

DeliverySelector.propTypes = {
    elipsis: PropTypes.number
};

export default DeliverySelector;
